import { type ReactNode } from "react";

import { HEIGHT, SETTINGS } from "~/shared/lib/design-tokens";
import { cn } from "~/shared/lib/utils";

export function SectionLabel({ children }: { children: ReactNode }) {
    return (
        <div className="mb-2.5 text-[11px] font-medium tracking-[0.12em] text-zinc-500 uppercase">
            {children}
        </div>
    );
}

export function Section({ label, children, hint }: { label: string; children: ReactNode; hint?: string }) {
    return (
        <div>
            <SectionLabel>{label}</SectionLabel>
            {children}
            {hint && <div className="mt-2 text-[11px] text-zinc-500">{hint}</div>}
        </div>
    );
}

interface TileBtnProps {
    label: string;
    active: boolean;
    onClick: () => void;
    disabled?: boolean;
    title?: string;
}

export function TileBtn({ label, active, onClick, disabled = false, title }: TileBtnProps) {
    return (
        <button
            type="button"
            onClick={onClick}
            disabled={disabled}
            title={title}
            aria-disabled={disabled || undefined}
            className={cn(
                HEIGHT.tile,
                SETTINGS.tilePad,
                "inline-flex items-center justify-center rounded-md text-xs font-medium",
                "[touch-action:manipulation] transition-colors duration-100 select-none",
                active
                    ? "bg-violet-500/20 text-violet-100 ring-1 ring-violet-400/50 ring-inset"
                    : "text-zinc-500 hover:bg-white/5 hover:text-zinc-300",
                disabled && "cursor-not-allowed opacity-60 hover:bg-transparent hover:text-zinc-500",
                disabled && active && "hover:bg-violet-500/20 hover:text-violet-100",
            )}
        >
            {label}
        </button>
    );
}
